import React, { useEffect } from "react"
import { ModalSeeker } from "@ui-seeker/core"
import { openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { isEmpty } from "@ui-seeker/utils"
import AnalyzerEvolutionChart from "Pages/AnalyzersV2/@components/EvolutionModal/Chart"
import useEvolutionModalData from "Pages/AnalyzersV2/@components/EvolutionModal/@hooks/useData"


export default function AnalyzerEvolutionModal({ isRating = false }) {
	const {
		onSubmit, isLoading, keySeries, chartData, setIsVisible, setIsLoading, officeData, executionDateTime,
		isByExecution, canGroupByExecution, toggleByExecution
	} = useEvolutionModalData({ isRating })

	useEffect(() => {
		if (!isEmpty(openEvolutionModal.value)) onSubmit()
	}, [openEvolutionModal.value])


	return <ModalSeeker
		isOpen={!isEmpty(openEvolutionModal.value)}
		controller={() => openEvolutionModal.value = {}}
		containerProps={{ fullScreen: true }}
		hideActions
	>
		<AnalyzerEvolutionChart
			chartData={chartData}
			keySeries={keySeries}
			isLoading={isLoading}
			isRating={isRating}
			setIsVisible={setIsVisible}
			setIsLoading={setIsLoading}
			officeData={officeData}
			executionDateTime={executionDateTime}
			isByExecution={isByExecution}
			canGroupByExecution={canGroupByExecution}
			toggleByExecution={toggleByExecution}
		/>
	</ModalSeeker>
}